<template>
    <div>
        <v-data-table
            :single-select="true"
            item-key="id"
            :headers="headers"
            :items="instructors"
            :loading="loading"
            loading-text="Loading ... please wait"
            :loader-height="6"
            hide-default-footer
            disable-pagination
        >
            <template v-slot:item.name="{ item }">
                <v-row class="align-center my-1">
                    <a :href="item.url">
                        <v-avatar size="40" color="secondary" class="my-1 mr-2">
                            <v-img
                                :src="$_.get(item, 'profile_photo_url', '')"
                                max-height="36"
                                max-width="36"
                            ></v-img>
                        </v-avatar>
                        <span>{{ item.name }}</span>
                    </a>
                </v-row>
            </template>
            <template v-slot:item.registered="{ item }">
                <v-icon v-if="item.registered" color="primary" large>
                    mdi-check-circle
                </v-icon>
                <v-icon v-else color="error darken-2" large>
                    mdi-close-circle
                </v-icon>
            </template>
            <template v-slot:item.verified="{ item }">
                <v-icon v-if="item.verified" color="primary" large>
                    mdi-check-circle
                </v-icon>
                <v-icon v-else color="error darken-2" large>
                    mdi-close-circle
                </v-icon>
            </template>
            <template v-slot:item.instructorName="{ item }">
                <v-row class="align-center">
                    <v-avatar size="40" color="secondary" class="my-1 mr-2">
                        <v-img
                            :src="$_.get(item, 'instructorProfileUrl', '')"
                            max-height="36"
                            max-width="36"
                        ></v-img>
                    </v-avatar>
                    <span>{{ item.instructorName }}</span>
                </v-row>
            </template>
            <template v-slot:item.programName="{ item }">
                <v-row class="align-center">
                    <v-avatar size="40" color="secondary" class="my-1 mr-2">
                        <v-img
                            :src="$_.get(item, 'programIconPath', '')"
                            max-height="36"
                            max-width="36"
                        ></v-img>
                    </v-avatar>
                    <span>{{ item.programName }}</span>
                </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
                <psi-action-drop-down
                    :heading="`Actions - ${$_.get(item, 'name')}`"
                    :items="filteredActions"
                    @action="$emit('action', item.id, $event)"
                ></psi-action-drop-down>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    name: "program-instructor-list",
    components: {},
    props: {
        instructors: {
            type: Array,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            filteredActions: [],
            actions: [
                {
                    name: "view-dashboard",
                    title: "View Dashboard",
                    icon: "mdi-school",
                    permission: "instructors.view-any",
                },
                {
                    divider: true,
                    permission: "programs.edit",
                },
                {
                    name: "resend-instructor-invite",
                    title: `Resend Invite`,
                    icon: "mdi-email-send",
                    permission: "instructors.view-any",
                },
            ],
            headers: [
                {
                    text: "Instructor",
                    align: "start",
                    sortable: false,
                    value: "name",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                    cellClass: "py-2",
                },
                {
                    text: "Last Login",
                    align: "start",
                    sortable: false,
                    value: "last_logged_in",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Email",
                    align: "start",
                    sortable: false,
                    value: "email",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Registered",
                    align: "center",
                    sortable: false,
                    value: "registered",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                // {
                //     text: "Verified",
                //     align: "center",
                //     sortable: false,
                //     value: "verified",
                //     class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                // },

                {
                    text: "Program",
                    align: "start",
                    sortable: false,
                    value: "programName",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
                {
                    text: "Actions",
                    align: "start",
                    sortable: false,
                    value: "actions",
                    class: "text-subtitle-2 font-weight-medium primary--text text-uppercase",
                },
            ],
        };
    },
    watch: {
        authUser: {
            immediate: true,
            handler() {
                this.filteredActions = this.actions.filter((action) =>
                    this.can(action.permission)
                );
            },
        },
    },

    methods: {
        // eslint-disable-next-line no-unused-vars
        filterPrograms(value, search, item) {
            return (
                search === undefined ||
                search === null ||
                item.name.toLowerCase().includes(search.toLowerCase()) ||
                item.instructors.some((ins) =>
                    ins.name.toLowerCase().includes(search.toLowerCase())
                )
            );
        },
    },
};
</script>

<style lang="scss" scoped>
</style>